module.exports = __webpack_public_path__ + "img/image00001.cc8145f6.jpg";